// src/components/pages/readyfortickets/Confirmation.jsx

import React from "react";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";

const Confirmation = ({ eventDetails }) => {
  return (
    <div className="bg-white shadow-md rounded-lg overflow-hidden max-w-md mx-auto">
      <ToastContainer position="top-right" autoClose={3000} limit={3} />
      
      {/* Compact Header */}
      <div className="bg-[#0A2533] py-3 px-4 flex items-center">
        <div className="w-10 h-10 bg-[#F57C00] rounded-full flex items-center justify-center mr-3">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
          </svg>
        </div>
        <div>
          <h2 className="text-lg font-bold text-white leading-tight">Purchase Confirmed</h2>
          <p className="text-xs text-white text-opacity-80">Ticket #{eventDetails.ticket}</p>
        </div>
      </div>
      
      {/* Ticket Design - More Compact */}
      <div className="p-4" style={{backgroundColor: "#FFF8EB"}}>
        {/* Event & Venue Info */}
        <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-4">
          <div className="border-l-4 border-[#F57C00] pl-3 py-2">
            <h3 className="font-bold text-[#0A2533]">{eventDetails.event_name || "Event Ticket"}</h3>
            <p className="text-xs text-gray-600">{eventDetails.start_date} • {eventDetails.time}</p>
          </div>
          
          <div className="px-4 py-3">
            {/* Venue with Icon */}
            <div className="flex items-start mb-3">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-[#F57C00] mt-0.5 mr-2 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
              </svg>
              <div className="text-sm">
                <p className="font-medium text-[#0A2533]">{eventDetails.venue_name || "Venue"}</p>
                <p className="text-xs text-gray-600">{eventDetails.venue_address}, {eventDetails.venue_post_code}</p>
              </div>
            </div>
            
            {/* Compact Grid of Details */}
            <div className="grid grid-cols-2 gap-2 text-xs">
              <div className="flex">
                <span className="text-gray-500 w-16">Category:</span>
                <span className="font-medium">{eventDetails.category_name || "General"}</span>
              </div>
              <div className="flex">
                <span className="text-gray-500 w-16">Quantity:</span>
                <span className="font-medium">{eventDetails.ticket_quantity || 1}</span>
              </div>
              <div className="flex">
                <span className="text-gray-500 w-16">Price:</span>
                <span className="font-medium">£{Number(eventDetails.price).toFixed(2)}</span>
              </div>
              <div className="flex">
                <span className="text-gray-500 w-16">Total:</span>
                <span className="font-medium">£{Number(eventDetails.total).toFixed(2)}</span>
              </div>
            </div>
          </div>
        </div>
        
        {/* QR Notice */}
        <div className="bg-white rounded-lg overflow-hidden shadow-sm p-3 mb-4">
          <div className="flex items-center">
            <div className="mr-3 text-[#F57C00]">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" />
              </svg>
            </div>
            <div>
              <h4 className="font-medium text-[#0A2533] text-sm">Your QR Ticket is Ready</h4>
              <p className="text-xs text-gray-600">
                Check your email or account dashboard to view your ticket with QR code.
              </p>
            </div>
          </div>
        </div>
        
        {/* Action Buttons - Compact Row */}
        <div className="grid grid-cols-2 gap-2">
          <Link to="/dashboard?section=purchase-history" className="bg-[#F57C00] text-center py-2 px-3 rounded text-white text-sm font-medium hover:bg-[#E67000] transition duration-150">
            My Tickets
          </Link>
          <Link to="/" className="border border-[#0A2533] text-center py-2 px-3 rounded text-[#0A2533] text-sm font-medium hover:bg-gray-50 transition duration-150">
            More Events
          </Link>
        </div>
        
        {/* Next Steps - Very Compact */}
        <div className="mt-4 bg-white p-3 rounded-lg text-xs">
          <div className="flex">
            <div className="w-5 h-5 bg-[#0A2533] text-white rounded-full flex items-center justify-center mr-2 flex-shrink-0">1</div>
            <p>Check your email for the ticket with QR code</p>
          </div>
          <div className="flex mt-1.5">
            <div className="w-5 h-5 bg-[#0A2533] text-white rounded-full flex items-center justify-center mr-2 flex-shrink-0">2</div>
            <p>Save the ticket to your phone or print it</p>
          </div>
          <div className="flex mt-1.5">
            <div className="w-5 h-5 bg-[#0A2533] text-white rounded-full flex items-center justify-center mr-2 flex-shrink-0">3</div>
            <p>Present the QR code at the event entrance</p>
          </div>
        </div>
        
        {/* Footer Message */}
        <p className="mt-3 text-[10px] text-center text-gray-500">
          Thank you for choosing EventFull Sunday! For support, contact help@eventfullsunday.com
        </p>
      </div>
    </div>
  );
};

export default Confirmation;
